import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

/* Fetch all founders data for admin */
export const getAllFoundersData = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/founders/admin`);
        return response.data;
    } catch (error) {
        console.error("Error fetching founders data:", error);
        throw error;
    }
};

/* Create founder data */
export const createFounderData = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/founders`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating founder data:", error);
        throw error;
    }
};

/* Update founder data */
export const updateFounderData = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/founders/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating founder data with ID ${id}:`, error);
        throw error;
    }
};

/* Delete founder data */
export const deleteFounderData = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/founders/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting founder data with ID ${id}:`, error);
        throw error;
    }
};
